var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrancheta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_200_213",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_200_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 24.4998C5.19167 24.4998 4.64236 24.2714 4.18542 23.8144C3.72847 23.3575 3.5 22.8082 3.5 22.1665V5.83317C3.5 5.1915 3.72847 4.6422 4.18542 4.18525C4.64236 3.72831 5.19167 3.49984 5.83333 3.49984H10.7333C10.9861 2.79984 11.409 2.23595 12.0021 1.80817C12.5951 1.38039 13.2611 1.1665 14 1.1665C14.7389 1.1665 15.4049 1.38039 15.9979 1.80817C16.591 2.23595 17.0139 2.79984 17.2667 3.49984H22.1667C22.8083 3.49984 23.3576 3.72831 23.8146 4.18525C24.2715 4.6422 24.5 5.1915 24.5 5.83317V22.1665C24.5 22.8082 24.2715 23.3575 23.8146 23.8144C23.3576 24.2714 22.8083 24.4998 22.1667 24.4998H5.83333ZM5.83333 22.1665H22.1667V5.83317H5.83333V22.1665ZM8.16667 19.8332H16.3333V17.4998H8.16667V19.8332ZM8.16667 15.1665H19.8333V12.8332H8.16667V15.1665ZM8.16667 10.4998H19.8333V8.1665H8.16667V10.4998ZM14 4.95817C14.2528 4.95817 14.4618 4.87553 14.6271 4.71025C14.7924 4.54498 14.875 4.33595 14.875 4.08317C14.875 3.83039 14.7924 3.62137 14.6271 3.45609C14.4618 3.29081 14.2528 3.20817 14 3.20817C13.7472 3.20817 13.5382 3.29081 13.3729 3.45609C13.2076 3.62137 13.125 3.83039 13.125 4.08317C13.125 4.33595 13.2076 4.54498 13.3729 4.71025C13.5382 4.87553 13.7472 4.95817 14 4.95817Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrancheta);
export default __webpack_public_path__ + "static/media/prancheta.30cd1715ae11f3154421155a6a121573.svg";
export { ForwardRef as ReactComponent };